const areas = [
  {
    value: "Andalucía",
    label: "Andalucía",
    businessCountry: "es",
  },
  {
    value: "Aragón",
    label: "Aragón",
    businessCountry: "es",
  },
  {
    value: "Baleares",
    label: "Baleares",
    businessCountry: "es",
  },
  {
    value: "Canarias",
    label: "Canarias",
    businessCountry: "es",
  },
  {
    value: "Cantabria",
    label: "Cantabria",
    businessCountry: "es",
  },
  {
    value: "Castilla y León",
    label: "Castilla y León",
    businessCountry: "es",
  },
  {
    value: "Castilla-La Mancha",
    label: "Castilla-La Mancha",
    businessCountry: "es",
  },
  {
    value: "Cataluña",
    label: "Cataluña",
    businessCountry: "es",
  },
  {
    value: "Ceuta",
    label: "Ceuta",
    businessCountry: "es",
  },
  {
    value: "Comunidad de Madrid",
    label: "Comunidad de Madrid",
    businessCountry: "es",
  },
  {
    value: "Comunidad Foral de Navarra",
    label: "Comunidad Foral de Navarra",
    businessCountry: "es",
  },
  {
    value: "Comunidad Valenciana",
    label: "Comunidad Valenciana",
    businessCountry: "es",
  },
  {
    value: "Extremadura",
    label: "Extremadura",
    businessCountry: "es",
  },
  {
    value: "Galicia",
    label: "Galicia",
    businessCountry: "es",
  },
  {
    value: "La Rioja",
    label: "La Rioja",
    businessCountry: "es",
  },
  {
    value: "Melilla",
    label: "Melilla",
    businessCountry: "es",
  },
  {
    value: "País Vasco",
    label: "País Vasco",
    businessCountry: "es",
  },
  {
    value: "Principado de Asturias",
    label: "Principado de Asturias",
    businessCountry: "es",
  },
  {
    value: "Región de Murcia",
    label: "Región de Murcia",
    businessCountry: "es",
  },
];

export function areasList(country = "es") {
  return areas.filter((area) => area.businessCountry === country);
}
